export var getDefaultStyle = function (visible) { return ({
    display: visible ? 'flex' : 'none',
}); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-loader-spinner/dist/esm/helpers.js
// module id = 91
// module chunks = 0